<mat-expansion-panel displayMode="flat" [expanded]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <p>Tags</p>
    </mat-panel-title>
  </mat-expansion-panel-header>
  @if (hasEditAccess()) {
    <ng-container *ngFor="let control of controls()">
      @if (control.TagType.toLowerCase() === 'string') {
        <app-single-select-with-search
          [initialValue]="getInitialTagValue(control.TagKey)"
          [tag]="control"
          [disabled]="shouldDisableTagControl(control.TagKey)"
          [idPrefix]="buildTagIdPrefix(control.TagKey)"
          (selectedValue)="setTagValue($event, control.TagKey)"
          >
        </app-single-select-with-search>
      }
      @if (control.TagType.toLowerCase() === 'datetime') {
        <app-year-picker
          [initialValue]="getInitialTagValue(control.TagKey)"
          [tag]="control"
          [disabled]="shouldDisableTagControl(control.TagKey)"
          [idPrefix]="buildTagIdPrefix(control.TagKey)"
          (selectedValue)="setTagValue($event, control.TagKey)"
          >
        </app-year-picker>
      }
    </ng-container>
  }
  @if (!hasEditAccess()) {
    @if (initialValue.length === 0) {
      <p>No tags are associated with this file.</p>
    }
    @if (initialValue.length > 0) {
      @for (tag of initialValue; track tag; let tagIndex = $index) {
        <mat-form-field class="w-p-90" appearance="outline">
          <input
            matInput
            disabled
            [value]="tag.TagValue"
            [attr.id]="buildReadOnlyFieldId(tag.TagKey, tagIndex)"
            />
          </mat-form-field>
        }
      }
    }
  </mat-expansion-panel>
  @if (hasEditAccess()) {
    @if (!isMultipleTags) {
      <div class="mt-20">
        <button
          (click)="onSubmit()"
          mat-button
          color="accent"
          class="ghost w-100"
          [class.disabled-save-button]="shouldDisableTagOptions()"
          [disabled]="shouldDisableTagOptions()"
          [attr.id]="buildActionId('btn-save')"
          >
          Save
        </button>
      </div>
    }
    @if (isMultipleTags) {
      <div class="mt-20">
        <button
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          class="button_content primary-hover grid-element-detail"
          [class.disabled-save-button]="shouldDisableTagOptions()"
          [disabled]="shouldDisableTagOptions()"
          [attr.id]="buildActionId('btn-save')"
          >
          Save
        </button>
        <button
          mat-button
          class="button_content grid-element-detail"
          color="primary"
          (click)="cancel()"
          [attr.id]="buildActionId('btn-cancel')"
          >
          Cancel
        </button>
      </div>
    }
  }
